import { useIntl } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';
import HeadMeta from '@/components/static-pages/HeadMeta';
import { WishlistsTemplate } from '@/components/wishlists';

const Wishlists: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="px-6 py-10 md:px-0 md:py-12">
      <HeadMeta
        title={intl.formatMessage({
          defaultMessage: 'Wishlist',
          id: 'hp3uqR',
        })}
        noindex
      />

      <MaxWidth className="justify-center px-0 mx-auto md:px-4 lg:pl-3 lg:pr-2">
        <WishlistsTemplate />
      </MaxWidth>
    </div>
  );
};

export default Wishlists;
